import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { hasPrivilege, USER_READ } from 'utils/privileges';
import getLocalisedDate from 'utils/dates/getLocalisedDate';
import Box from 'components/Box';
import { AdminOrHubTextLink } from 'components/AdminOrHubLink';
import Icon from 'components/Icon';
import DetailsDropdown from './DropdownInfo';
import i18n from 'i18n';
export var dateOptions = {
  month: 'numeric',
  year: 'numeric',
  day: 'numeric'
};
function AuthorText(_ref) {
  var author = _ref.author;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isUserAdmin = hasPrivilege(USER_READ);
  var link = author.isDeleted ? "/users?search=".concat(encodeURIComponent("id:".concat(author.id, " userDomains.isDeleted:1"))) : "/users?search=".concat(encodeURIComponent("id:".concat(author.id)));
  if (isUserAdmin) {
    return /*#__PURE__*/React.createElement(Trans, {
      t: t,
      i18nKey: "content_info_created_by_author_link",
      values: {
        author: author.displayName
      }
    }, "Created by", ' ', /*#__PURE__*/React.createElement(AdminOrHubTextLink, {
      bold: true,
      link: link
    }, "author"));
  }
  return /*#__PURE__*/React.createElement(Trans, {
    t: t,
    i18nKey: "content_info_created_by_author",
    values: {
      author: author.displayName
    }
  }, "Created by ", /*#__PURE__*/React.createElement("strong", null, "author"));
}
function getDetailListItems(_ref2) {
  var content = _ref2.content;
  var lastUpdatedDate = content.lastUpdated ? getLocalisedDate({
    date: content.lastUpdated,
    options: dateOptions,
    fallbackVariant: 'hyphen',
    isInLocalTimezone: false
  }) : undefined;
  var createdDate = content.createdTime ? getLocalisedDate({
    date: content.createdTime,
    options: dateOptions,
    fallbackVariant: 'hyphen',
    isInLocalTimezone: false
  }) : undefined;
  var listItems = [content.author && /*#__PURE__*/React.createElement(AuthorText, {
    key: "author",
    author: content.author
  }), createdDate && i18n.t('content_info_created_date', {
    date: createdDate
  }), lastUpdatedDate && i18n.t('content_info_last_updated_date', {
    date: lastUpdatedDate
  })].filter(Boolean);
  return listItems;
}
export var ContentDetailsInfo = function ContentDetailsInfo(_ref3) {
  var content = _ref3.content,
    type = _ref3.type;
  var _useTranslation2 = useTranslation(),
    t = _useTranslation2.t;
  var listItems = getDetailListItems({
    content: content
  });
  if (!listItems.length) {
    return null;
  }
  var isPlaylist = type === 'playlist';
  var titleKey = isPlaylist ? 'property_playlist_info' : 'property_asset_info';
  return /*#__PURE__*/React.createElement(Box, {
    fontSize: "s"
  }, /*#__PURE__*/React.createElement(DetailsDropdown, {
    titleKey: titleKey,
    listItems: listItems
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "info",
    mr: "xxs"
  }), t(titleKey)));
};
export default ContentDetailsInfo;